import React, { CSSProperties } from "react"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import ArrowIcon from "components/atoms/_icons/ArrowIcon"
import IconWrapper from "components/atoms/IconWrapper"
import Switch from "components/atoms/Switch"
import MenuItemLoadingPlaceholder from "components/atoms/Menu/MenuItemLoadingPlaceholder"

type MenuItem = {
  key: string;
  label: string | React.ReactNode;
  icon: React.ReactNode;
  actionButton?: React.ReactNode;
  switchable?: boolean;
  defaultSwitchValue?: boolean;
  loading?: boolean;
  menuStyle?: CSSProperties;
  onClick?: () => void;
}

type MenuProps = {
  menuItems: MenuItem[];
}

export default function Menu({ menuItems }: MenuProps) {
  function handleMenuItemClick(item: MenuItem): void {
    if (item.loading) return
    if (!item.switchable && item.onClick) {
      item.onClick()
    }
  }

  return <Stack sx={{ backgroundColor: "#FFFFFF", borderRadius: "4px", overflow: "hidden", marginTop: "12px" }}>
    {menuItems.map((item, index) => (
      <Stack key={item.key} alignItems="space-between" justifyContent="center" padding="4px 16px">
        <MenuItem
          style={{ ...item.menuStyle || {} }}
          onClick={() => handleMenuItemClick(item)}
        >
          {!item.loading ? <>
            <IconWrapper id={item.key}>
              {item.icon}
            </IconWrapper>
            <Label>{item.label}</Label>
            {item.actionButton ? item.actionButton : <>
              {(item.switchable && item.hasOwnProperty("defaultSwitchValue")) ? <Switch
                defaultChecked={!!item.defaultSwitchValue}
                disabled={true}
                onChange={() => {
                }}
              /> : <ArrowWrapper>
                <ArrowIcon/>
              </ArrowWrapper>}
            </>}
          </> : <MenuItemLoadingPlaceholder/>}
        </MenuItem>
      </Stack>
    ))}
  </Stack>
}

const MenuItem = styled(Stack)(({ theme }) => ({
  height: "60px",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#FFFFFF",
  gap: "4px",
  padding: "8px 14px",
  borderRadius: "4px",
  boxShadow: `0 0 10px 0 ${theme.palette.gray["4"]}`,

  "& svg:not[role=img]": {
    stroke: theme.palette.gray["14"]
  },

  "& div#upgrade-to-pro svg": {
    stroke: "none"
  }
}))

const Label = styled("div")(({ theme }) => ({
  fontSize: "1.4rem",
  fontWeight: 500,
  color: theme.palette.gray["14"],
  marginRight: "auto"
}))

const ArrowWrapper = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",

  "& svg": {
    stroke: theme.palette.primary["6"],
    width: 24,
    height: 24
  }
}))
